export enum AppName {
	'booking' = 'booking',
	'booking-demo' = 'booking-demo',
	'booking-person' = 'booking-person',
	'bookingCalendar' = 'bookingCalendar',
	'card-management-demo' = 'card-management-demo',
	'disposition-demo' = 'disposition-demo',
	'evaluation' = 'evaluation',
	'home' = 'home',
	'jobs' = 'jobs',
	'login' = 'login',
	'maintenance' = 'maintenance',
	'notiDispatcher' = 'notiDispatcher',
	'onClient' = 'onClient',
	'password' = 'password',
	'planTemplate' = 'planTemplate',
	'presenceStatus' = 'presenceStatus',
	'report' = 'report',
	'resourceCalendar' = 'resourceCalendar',
	'terminal' = 'terminal',
	'timeline' = 'timeline',
	'timelineTask' = 'timelineTask',
	'workflow' = 'workflow',
	'workflow1' = 'workflow1',
	'workflow2' = 'workflow2',
}

const urlString = window.location.pathname;
const str = urlString.substring(urlString.lastIndexOf("/") + 1, urlString.indexOf(".jsp"));
const appName = Object.values(AppName).filter(x => AppName[x] === str)[0];
if (!appName) {
	console.error('missing AppName')
}

export const getAppName = (): AppName => {
	return appName;
};